import React from 'react';
import { Button, Checkbox } from '@mui/material';
import Dialog, { DialogProps } from '../../../../components/dialog/Dialog';

interface DeleteBlockModalProps extends DialogProps {
    showWarning: boolean;
    setShowWarning: (show: boolean) => void;
    onDelete: () => void;
}

const DeleteBlockModal: React.FC<DeleteBlockModalProps> = ({ onDelete, showWarning, setShowWarning, ...props }) => {
    return (
        <Dialog {...props}>
            <div className="mt-12 px-24 pb-40">
                <p className="text-14 text-primary-80 text-center">
                    Are you sure you want to delete this block? Once removed, it can’t be recovered.
                </p>
                <div className="mt-12 flex items-center justify-center text-14 text-primary-80">
                    <Checkbox
                        size={`medium`}
                        checked={!showWarning}
                        onChange={(_, checked) => setShowWarning(!checked)}
                    />
                    <p>Don’t Show Again</p>
                </div>
                <div className="flex items-center mt-12 -mx-5">
                    <div className={`flex-1 px-5`}>
                        <Button
                            size={`medium`}
                            color={`primary`}
                            variant="outlined"
                            fullWidth={true}
                            onClick={props.onClose}
                        >
                            Cancel
                        </Button>
                    </div>
                    <div className={`flex-1 px-5`}>
                        <Button
                            size={`medium`}
                            color={`error`}
                            variant={'outlined'}
                            fullWidth={true}
                            onClick={onDelete}
                        >
                            Delete
                        </Button>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default DeleteBlockModal;
